module.exports = __webpack_public_path__ + "static/media/empower.c3815c26.jpg";